import Script from 'components/script/Script';
import React from 'react';

const ScriptTab = () => {
  return (
    <div>
      <Script/>
    </div>
  );
};

export default ScriptTab;
